export default {
      id: "marker-usage",
      viewBox: "0 0 24 32",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#marker",
      toString: function () {
        return this.url;
      }
    }